<template>
	<div class="container">
		<div class="layout-chat-main">
			<div class="chat-header" v-if="_chatObj">
				<!-- <span>{{ _chatObj.lunciUser.nickname }}的聊天（协助模式中）</span> -->
				<div class="left-box">
					<div class="ml10 completed-btn top-public-btn" v-if="_chatObj.helpStatus == 1">
						<img class="icon" src="../../../static/icon/chat-header-ywc-icon.png" /> 已完成
					</div>
					<div class="ml10 no-completed-btn top-public-btn" v-if="_chatObj.helpStatus == 0">
						<img class="icon" src="../../../static/icon/chat-header-wwc-icon.png" /> 协助中
					</div>
				</div>
				<div class="right-box" v-if="!_chatObj.helpStatus == 1">
					<el-popconfirm title="确认结束协助，是否继续？" @confirm="onChangeXzStatus('end')">
						<div class="end-btn top-public-btn ml10" slot="reference">
							<img class="icon" src="../../../static/icon/chat-header-end-on-icon.png" />结束
						</div>
					</el-popconfirm>
					<!-- :class="{ active: !xzConfig.helpInfo.isAbleReturn }" v-if="xzConfig.helpInfo.isAbleReturn"  v-else -->
					<el-popconfirm title="确认返回协助，是否继续？" @confirm="onChangeXzStatus('return')">
						<div class="back-btn top-public-btn ml10" :class="{ active: !xzConfig.helpInfo.isAbleReturn }"
							slot="reference">
							<img class="icon" src="../../../static/icon/chat-header-back-on-icon.png" />
							<!-- <img class="icon" src="../../../static/icon/chat-header-back-icon.png" /> -->
							返回
						</div>
					</el-popconfirm>
				</div>
			</div>
			<chat-box id="chatbox" ref="chatBox" :_chatDialogs="_chatDialogs" @onPause="onPause"></chat-box>
			<div class="chat-input">
				<div class="opt-panel">
					<!-- 模型选择按钮（与 chat-v2 同款，点击打开 ModelSelectDialog） -->
					<div class="model-select-btn mr4" @click="modelDialogVisible = true">
						<span class="model-vendor-dot" :style="{ background: selectedModelColor }"></span>
						<span class="model-name">选择AI模型：{{ selectedModelName }}</span>
						<i class="el-icon-arrow-down"></i>
					</div>
					<!-- <el-dropdown trigger="click" class="mr4">
          <el-button size="mini" round class="el-dropdown-link" style="padding: 6px 10px; margin-bottom: 0">
            <i class="iconfont icon-setting mr4"></i> 选择AI模型 ：{{ selectModel.name }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="choooseModel(value)" v-for="{ name, value } of models" :key="value">{{ name
              }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
					<el-dropdown trigger="click" class="mr4">
						<!-- <el-button round class="el-dropdown-link" style="padding: 6px 10px; margin-bottom: 0">
            <i class="iconfont icon-robot2 mr4"></i> 选择AI角色<span v-if="selectRole.type === 'base'">：{{ selectRole.name
              }}</span>
          </el-button> -->
						<div class="role-select-btn">
							选择AI角色<span v-if="selectRole.type === 'base'">：{{ selectRole.name }}</span>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="item of baseRoles" :key="item.id">
								<div class="flex role-drop-box">
									<div class="role-drop-title mr-4" @click="choooseRole(item, 'base')">
										{{ item.name }}
									</div>
									<!-- <el-button
									size="mini"
									icon="el-icon-edit"
									v-if="item.isEdit"
									@click="onEditRole(item)"
								></el-button>
								<el-button
									size="mini"
									icon="el-icon-delete"
									v-if="item.isDelete"
									@click="onDeleteRole(item)"
								></el-button> -->
								</div>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-dropdown trigger="click" class="mr4">
						<!-- <el-button round class="el-dropdown-link" style="padding: 6px 10px; margin-bottom: 0">
            <i class="iconfont icon-robot2 mr4"></i> 查看协作角色<span v-if="selectRole.type === 'xz'">：{{ selectRole.name
              }}</span>
          </el-button> -->
						<div class="role-select-btn" @click="onXzRole">
							选择协助角色<span v-if="selectRole.type === 'xz'">：{{ selectRole.name }}</span>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="item of roles" :key="item.id">
								<div class="flex role-drop-box">
									<div class="role-drop-title mr-4" @click="choooseRole(item, 'xz')">
										{{ item.name }}
									</div>
									<el-button size="mini" icon="el-icon-edit" v-if="item.isEdit" @click="onEditRole(item)"></el-button>
									<el-button size="mini" icon="el-icon-delete" v-if="item.isDelete"
										@click="onDeleteRole(item)"></el-button>
								</div>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!-- <el-button @click="addRolePop" size="mini" round class="el-dropdown-link">
          <i class="iconfont el-icon-circle-plus-outline mr4"></i> 新增协作角色
        </el-button> -->
					<div class="clean-chat-btn mr4" @click="addRolePop">新增协作角色</div>
					<!-- <el-button @click="cleanDialogs" size="mini" round class="mr4">
          <i class="iconfont el-icon-brush mr4"></i> 清除聊天记录
        </el-button> -->
					<div class="clean-chat-btn mr4" @click="cleanDialogs">清除聊天记录</div>
					<!-- <el-button :disabled="!isSupportImg" v-if="msgImgsCount == 0" size="mini" round style="padding: 5px 10px"
          class="ml4" @click="imgInputVisible = true">
          <i class="el-icon-upload2"></i> 图像
        </el-button>
        <el-badge :value="msgImgsCount" v-if="msgImgsCount > 0" class="ml4">
          <el-button :disabled="!isSupportImg" size="mini" round style="padding: 5px 10px"
            @click="imgInputVisible = true">
            <i class="el-icon-upload2"></i> 图像
          </el-button>
        </el-badge>
        <el-button type="success" style="margin-left: auto" class="ml4" size="mini" @click="waitingImage">
          <i class="el-icon-picture mr4"></i> 绘画
        </el-button> -->
					<!-- 图片上传：仅 isImageRecognition=1 时显示（与 chat-v2 一致） -->
					<el-tooltip v-if="modelDetail.isImageRecognition === 1" content="上传图片" placement="top">
						<div class="upload-btn mr4" @click="$refs.imageInput.click()">
							<i class="el-icon-picture-outline"></i>
							<span>图片</span>
						</div>
					</el-tooltip>

					<!-- 文件上传：始终显示（与 chat-v2 一致） -->
					<el-tooltip content="支持 txt / md / csv / docx / xlsx / pdf / pptx（≤5MB）" placement="top">
						<div class="upload-btn mr4" @click="$refs.fileInput.click()">
							<i class="el-icon-paperclip"></i>
							<span>文件</span>
						</div>
					</el-tooltip>

					<!-- 视频识别上传：保留老链路（chat-v2 暂无该能力） -->
					<div class="clean-chat-btn mr4" @click="onShowPop('video')" :disabled="modelDetail.isVideoRecognition == 0"
						v-if="msgVideoCount == 0 && modelDetail.isVideoRecognition == 1">
						<i class="el-icon-upload2"></i> 上传视频
					</div>
					<el-badge :value="msgVideoCount" v-if="msgVideoCount > 0" class="ml4">
						<div class="clean-chat-btn mr4" @click="onShowPop('video')" :disabled="modelDetail.isVideoRecognition == 0">
							<i class="el-icon-upload2"></i> 上传视频
						</div>
					</el-badge>
				</div>

				<!-- 附件预览区（图片缩略图 / 文件卡片） -->
				<div class="attachments" v-if="uploadedImages.length > 0 || uploadedFiles.length > 0">
					<div class="attachment-img" v-for="(img, i) in uploadedImages" :key="'img'+i">
						<img :src="img.preview" class="img-thumb" />
						<i class="el-icon-circle-close remove-btn" @click="removeImage(i)"></i>
					</div>
					<div class="attachment-file" v-for="(f, i) in uploadedFiles" :key="'file'+i">
						<i :class="fileTypeIcon(f.type)" class="file-icon"></i>
						<div class="file-info">
							<span class="file-name">{{ f.name }}</span>
						</div>
						<i class="el-icon-circle-close remove-btn" @click="removeFile(i)"></i>
					</div>
				</div>

				<!-- 隐藏的文件输入 -->
				<input
					type="file"
					ref="imageInput"
					accept="image/jpeg,image/png,image/webp,image/gif"
					multiple
					style="display:none"
					@change="onImageSelect"
				/>
				<input
					type="file"
					ref="fileInput"
					accept=".txt,.md,.csv,.docx,.xlsx,.xls,.pdf,.pptx"
					multiple
					style="display:none"
					@change="onFileSelect"
				/>

				<div class="chat-input-box">
					<div class="input-box">
						<el-input type="textarea" :disabled="!reqAiConfig.isSend" :autosize="{ minRows: 2, maxRows: 12 }"
							placeholder="请输入内容" v-model="textarea" resize="none"></el-input>
						<!-- <el-button size="mini" round class="el-dropdown-link" style="padding: 6px 10px; margin-bottom: 0"
            @click="isPrviewShow = true">
            <i class="el-icon-full-screen"></i> 预览
          </el-button> -->
					</div>

					<div class="send-icon">
						<img class="icon" @click="send" src="../../../static/icon/send-icon.png" />
					</div>
				</div>
			</div>

			<el-dialog title="视频上传" :visible.sync="videoInputVisible" width="500px">
				<div class="center">
					<el-upload ref="videoRef" name="video" list-type="text" :limit="1" :on-success="videoUploadSuccess"
						:before-remove="videoBeforeRemove" accept=".mp4" :on-exceed="handleExceed" drag
						:action="`${config.baseUrl}user/api.userinfo/uploadVideo`">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">请上传MP4文件并且大小不超过100M的视频文件</div>
					</el-upload>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="videoInputVisible = false">确 定</el-button>
				</span>
			</el-dialog>
			<el-dialog title="预览" :visible.sync="isPrviewShow" :close-on-click-modal="false" width="800px">
				<el-input type="textarea" :rows="20" placeholder="请输入内容" v-model="textarea"></el-input>
			</el-dialog>
			<el-dialog :title="addRoleFrom.isAdd ? '新增协助角色' : '修改协助角色'" :visible.sync="isAddRoleShow"
				:close-on-click-modal="false" width="1000px">
				<el-form ref="addForm" :model="addRoleFrom" class="demo-form-inline" :rules="rules" label-width="120px">
					<el-form-item label="新增方式" prop="roleAddType">
						<el-radio v-model="addRoleFrom.roleAddType" label="1" v-if="addRoleFrom.isAdd">AI员工导入</el-radio>
						<el-radio v-model="addRoleFrom.roleAddType" label="2">自定义角色</el-radio>
					</el-form-item>
					<el-form-item label="选择角色" prop="copywritingCategoryId" v-if="addRoleFrom.roleAddType === '1'">
						<el-select v-model="addRoleFrom.copywritingCategoryId" placeholder="请选择">
							<el-option :label="item.title" :value="item.id" v-for="item in classList" :key="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item label="选择历史角色导入" v-if="addRoleFrom.roleAddType === '2'">
						<el-select placeholder="请选择" v-model="addRoleFrom.historyGuid" @change="onChangeHistoryRole">
							<el-option :label="item.chatgtpContentTitle" :value="item" v-for="item in historyHelp" :key="item.guid" />
						</el-select>
					</el-form-item>
					<el-form-item label="自定义角色名" prop="chatgtpContentTitle" v-if="addRoleFrom.roleAddType === '2'">
						<el-input v-model="addRoleFrom.chatgtpContentTitle" />
					</el-form-item>
					<el-form-item label="自定义提示语" prop="chatgtpContent" v-if="addRoleFrom.roleAddType === '2'">
						<!-- <el-input type="textarea" :rows="2" v-model="createReqFrom.rule" placeholder="提示语" /> -->
						<v-md-editor v-model="addRoleFrom.chatgtpContent" height="400px"></v-md-editor>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit('addForm')">提交</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
		<div class="options-box">
			<!-- <div class="param-box">
        <div class="label">参数设置</div>
        <div class="title mt10">system_prompt</div>
        <div class="input-box mt10">
          <el-input class="inp" type="textarea" :rows="2" placeholder="请输入参数" v-model="reqAiConfig.systemPrompt"
            resize="none"></el-input>
          <el-button size="mini" round class="el-dropdown-link" style="padding: 2px 6px; margin-bottom: 0"
            @click="isPrviewShow = true">
            <i class="el-icon-full-screen"></i>
          </el-button>
        </div>
      </div> -->
			<div class="slider-box">
				<div class="item">
					<div class="title">
						max_tokens
						<el-tooltip class="item" effect="light" content="最大输出token数" placement="top-start"><i
								class="el-icon-warning-outline"></i></el-tooltip>
					</div>
					<div class="slider">
						<div class="label">{{ reqAiConfig.maxOutputTokens }}</div>
						<el-slider v-model="reqAiConfig.maxOutputTokens" :max="modelDetail.maxOutputTokens" :step="1"></el-slider>
					</div>
				</div>
				<div class="item">
					<div class="title">
						temperature
						<el-tooltip class="item" effect="light" content="采样温度，控制输出的随机性，取值范围是：[0.0, 1.0]" placement="top-start"><i
								class="el-icon-warning-outline"></i></el-tooltip>
					</div>
					<div class="slider">
						<div class="label">{{ reqAiConfig.temperature }}</div>
						<el-slider v-model="reqAiConfig.temperature" :step="0.1" :min="0" :max="1"></el-slider>
					</div>
				</div>
				<div class="item">
					<div class="title">
						top_p
						<el-tooltip class="item" effect="light" content="温度取样的另一种方法，取值范围是：[0.0, 1.0]" placement="top-start"><i
								class="el-icon-warning-outline"></i></el-tooltip>
					</div>
					<div class="slider">
						<div class="label">{{ reqAiConfig.topP }}</div>
						<el-slider v-model="reqAiConfig.topP" :step="0.1" :min="0" :max="1"></el-slider>
					</div>
				</div>
			</div>
			<div class="switch-box">
				<div class="label">工具调用</div>
				<div class="item">
					<div class="t">网页检索</div>
					<div class="switch">
						<el-switch v-model="modelDetail.isNetwork" :activeValue="1" :inactiveValue="0" active-color="#6126F5"
							inactive-color="#DEE0E4" disabled></el-switch>
					</div>
				</div>
				<!-- <div class="item">
          <div class="t">知识库检索</div>
          <div class="switch">
            <el-switch v-model="value" active-color="#6126F5" inactive-color="#DEE0E4"></el-switch>
          </div>
        </div>
        <div class="item">
          <div class="t">函数调用</div>
          <div class="switch">
            <el-switch v-model="value" active-color="#6126F5" inactive-color="#DEE0E4"></el-switch>
          </div>
        </div> -->
			</div>
			<div class="switch-box">
				<div class="item">
					<div class="t">多轮对话</div>
					<div class="switch">
						<el-switch v-model="reqAiConfig.isMultiple" active-color="#6126F5" inactive-color="#DEE0E4"></el-switch>
					</div>
				</div>
			</div>
		</div>

		<!-- 模型选择弹窗（复用 chat-v2 的弹窗组件） -->
		<model-select-dialog
			:visible.sync="modelDialogVisible"
			:selected-guid="reqAiConfig.aiModelGuid"
			@select="onModelChoose"
		></model-select-dialog>
	</div>
</template>

<script>
import ChatBox from '@/views/app/layout-chat/chat-box.vue';
import ModelSelectDialog from '@/views/app/layout-chat-v2/ModelSelectDialog.vue';
import { getToken } from '@/utils/auth';
import { requireChatResponse } from '@/utils/chat-response.mjs';
import {
	clearLunci,
	genImage,
	getAbleModels,
	getRobotRoles,
	saveChatDialog,
	helpRoleList,
	addHelpRole,
	editHelpRole,
	deleteHelpRole,
	getAiVendorListApi,
	getAiVendorModelListApi,
	lunciHelperUpdateStatusApi,
	historyHelpRolesApi,
	chatLunciHelpInfoApi,
} from '@/apis/chat';
import config from '@/apis/config.js'
import { getClassListApi, getClassContentListApi } from '@/apis/tools';
import { uploadImgApi, uploadDocFileApi } from '@/apis/user';
// import { merchantGuid } from '@/config';
export default {
	name: 'layout-chat-main',
	components: { ChatBox, ModelSelectDialog },

	async created() {
		try {
			const [models, roles] = await Promise.all([getAbleModels({ is_all_pc: 1 }), getRobotRoles()]);
			this.models = [...models, { name: '通用AI模型', value: '' }];
			this.baseRoles = [...roles, { name: '通用对话角色', value: '' }];
			await this.autoSelectFirstModel();
		} catch (error) {
			// 请求中断时不把 null 当成空目录，更不能继续向失败结果 push。
			this.$message({ message: error.message || '读取协助空间配置失败，请刷新重试', type: 'error' });
		}

		// WebSocket 与目录请求独立；目录偶发失败时页面仍可重连并再次获取配置。
		this.connectWs();
	},

	beforeDestroy() {
		this.closeWs();
	},

	props: {
		_chatDialogs: Array,
		_chatingId: String,
		_chatObj: Object,
	},

	data() {
		return {
			config,
			models: [],
			baseRoles: [],
			roles: [],
			// selectModelKey: '',
			// selectModel: { value: '', name: '通用AI模型', is_able_img: false },
			selectRoleKey: '',
			selectRole: { id: '', name: '通用对话角色', type: 'base' },
			textarea: '',
			msg: [],
			isNewGlobalMsg: false,
			// 图片
			msgImgs: [],
			videos: [],
			imgInputVisible: false,
			videoInputVisible: false,
			isPrviewShow: false,
			isAddRoleShow: false,
			isHelp: false,
			addRoleFrom: {
				isAdd: true,
				chatLunciGuid: '',
				roleAddType: '1',
				copywritingCategoryId: '',
				chatgtpContent: '',
				chatgtpContentTitle: '',
				historyGuid: '',
			},
			xzConfig: {
				helpInfo: {
					helpGuid: '',
					helpUser: {
						nickname: '',
						introduction: '',
						avatarUrl: '',
					},
					isAbleReturn: false,
					debugChatCount: 0,
				},
			},
			classList: [],
			helpList: [],
			rules: {
				copywritingCategoryId: [
					{
						required: true,
						message: '请选择角色',
						trigger: 'change',
					},
				],
				chatgtpContent: [
					{
						required: true,
						message: '请输入角色名',
						trigger: 'blur',
					},
				],
				chatgtpContentTitle: [
					{
						required: true,
						message: '请输入角色规则',
						trigger: 'blur',
					},
				],
			},
			// modelPopCofig 仅保留 modelName/guid 给图片/视频生成等老链路使用，下拉态不再需要
			modelPopCofig: {
				modelType: 'text',
				modelName: '请选择模型',
				guid: '',
			},

			// 模型选择弹窗（与 chat-v2 一致）
			modelDialogVisible: false,
			selectedModelName: '请选择模型',
			selectedModelVendor: '',
			enableThinking: false,

			// WebSocket 状态
			ws: null,
			wsReconnectTimer: null,
			wsConnected: false,
			streamingIdx: -1,
			_pendingLunci: null,
			_eventsReceived: 0,

			// 附件上传（与 chat-v2 一致：图片缩略图 + 文件卡片）
			uploadedImages: [],   // [{ preview, url }]
			uploadedFiles:  [],   // [{ name, url, type }]
			imageUploading: false,
			reqAiConfig: {
				msgId: '',
				roleId: '',
				content_cate_id: '',
				aiModelGuid: '',
				modelRef: null,
				roleType: '',
				chatScene: 'default',
				sceneValue: '',
				maxOutputTokens: 0,
				temperature: 0,
				topP: 0,
				systemPrompt: '',
				isMultiple: true,
				isSend: false,
				placeholder: '请输入您的问题或需求',
			},
			modelDetail: {
				maxOutputTokens: 0,
				modelType: 'text',
				isImageRecognition: 0,
				isVideoRecognition: 0,
			},
			aiModels: [],
			aiModelChildren: [],
			source: null,
			historyHelp: [],
		};
	},

	computed: {
		msgImgsCount() {
			return this.msgImgs.length;
		},
		msgVideoCount() {
			return this.videos.length;
		},
		// 模型按钮上的厂商色点（与 chat-v2 同款配色）
		selectedModelColor() {
			const map = {
				openrouter: '#8b5cf6',
				deepseek:   '#1d4ed8',
				zhipu:      '#059669',
				openai:     '#10b981',
				azure:      '#0078d4',
				closeai:    '#7c3aed',
			};
			return map[this.selectedModelVendor] || '#aaa';
		},
		// async _chatingId() {
		// 	this.getHelpRoleList();
		// },
	},
	watch: {
		_chatingId: {
			async handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.getHelpRoleList();
					this.getChatLunciHelpInfo();
				}
			},
			immediate: true,
		},
	},

	methods: {
		async onChangeXzStatus(status) {
			if (status === 'end') {
				try {
					let res = await lunciHelperUpdateStatusApi({
						helpLuinciGuid: this._chatObj.guid,
						status: status,
					});
					if (res.code == 0) {
						this.$message({
							message: '结束协助',
							type: 'success',
						});
						// 刷新 _chatObj 状态
						this.$emit('refreshChatList');
					} else {
						this.$message({
							message: res.msg,
							type: 'info',
						});
					}
					this.getChatLunciHelpInfo();
				} catch (error) {
					this.$message({
						message: error.msg,
						type: 'info',
					});
				}
			} else {
				if (this.xzConfig.helpInfo.isAbleReturn) {
					try {
						let res = await lunciHelperUpdateStatusApi({
							helpLuinciGuid: this._chatObj.guid,
							status: status,
						});
						if (res.code == 0) {
							this.$message({
								message: '返回成功',
								type: 'success',
							});
							// 刷新 _chatObj 状态
							this.$emit('refreshChatList');
						} else {
							this.$message({
								message: res.msg,
								type: 'info',
							});
						}
						this.getChatLunciHelpInfo();
					} catch (error) {
						this.$message({
							message: error.msg,
							type: 'info',
						});
					}
				}
			}
		},
		//修改协助角色
		onEditRole(item) {
			let obj = null;
			this.helpList.forEach(element => {
				if (element.sysId === item.id) {
					obj = element;
				}
			});
			if (obj) {
				this.addRoleFrom.roleAddType = '2';
				this.addRoleFrom.chatLunciGuid = obj.helpLunciGuid;
				this.addRoleFrom.guid = obj.guid;
				this.addRoleFrom.chatgtpContent = obj.chatgtpContent;
				this.addRoleFrom.chatgtpContentTitle = obj.chatgtpContentTitle;
				this.addRoleFrom.isAdd = false;
				this.isAddRoleShow = true;
			}
		},
		//删除协作角色
		onDeleteRole(item) {
			this.$confirm('是否删除该角色', '删除角色', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
			})
				.then(async () => {
					let obj = this.helpList.find(element => {
						return element.sysId === item.id;
					});
					await deleteHelpRole({ guid: obj.guid });
					this.getHelpRoleList();
					this.$message({
						type: 'success',
						message: '删除成功',
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消',
					});
				});
		},
		//新增协作角色
		onSubmit(formName) {
			this.$refs[formName].validate(async valid => {
				if (valid) {
					if (this.addRoleFrom.isAdd) {
						// this.addRoleFrom.roleAddType = '1';
						this.addRoleFrom.chatLunciGuid = this._chatingId;
						let res = await addHelpRole(this.addRoleFrom);
						if (res.code === 0) {
							this.$nextTick(() => {
								this.$refs[formName].resetFields();
							});
							this.$message({ message: '新增成功', type: 'success' });
							this.isAddRoleShow = false;
							this.getHelpRoleList();
						} else {
							this.$message({ message: '新增失败', type: 'error' });
						}
					} else {
						let res = await editHelpRole(this.addRoleFrom);
						if (res.code === 0) {
							this.$nextTick(() => {
								this.$refs[formName].resetFields();
							});
							this.$message({ message: '修改成功', type: 'success' });
							this.isAddRoleShow = false;
							this.getHelpRoleList();
						} else {
							this.$message({ message: '修改失败', type: 'error' });
						}
					}
				} else {
					return false;
				}
			});
		},
		//聊天轮次协助详情
		async getChatLunciHelpInfo() {
			let res = await chatLunciHelpInfoApi({ chatLunciGuid: this._chatingId });
			if (res.code === 0) {
				this.xzConfig.isHelp = res.data.isHelp;
				if (res.data.isHelp) {
					this.xzConfig.helpInfo = res.data.helpInfo;
				}
			}
		},
		async getClassList() {
			let cateList = await getClassListApi({
				cateType: 'text',
				merchantGuid: this.$store.state.merchantGuid,
			});
			cateList.data.forEach(async item => {
				let res = await getClassContentListApi({
					cateId: item.id,
				});
				this.classList.push(...res.data);
			});
			// this.classList.push(...res.data);
			// this.sceneListId = res.data[0].id;
			// this.getClassContentList();
		},
		addRolePop() {
			this.addRoleFrom.isAdd = true;
			this.isAddRoleShow = true;
			this.historyHelpRoles();
		},
		async historyHelpRoles() {
			let res = await historyHelpRolesApi();
			this.historyHelp = res.data;
		},
		onChangeHistoryRole(item) {
			this.addRoleFrom.chatgtpContentTitle = item.chatgtpContentTitle;
			this.addRoleFrom.chatgtpContent = item.chatgtpContent;
		},
		async getHelpRoleList() {
			if (!this._chatingId) return;
			try {
				const { data } = requireChatResponse(await helpRoleList({ chatLunciGuid: this._chatingId }), '读取协助角色失败');
				const list = Array.isArray(data) ? data : [];
				this.helpList = list;
				this.roles = list.map(item => ({
					id: item.sysId,
					name: item.showRoleName,
					isHelp: true,
					isDelete: item.isDelete,
					isEdit: item.isEdit,
				}));
			} catch (error) {
				this.$message({ message: error.message || '读取协助角色失败，请稍后重试', type: 'error' });
			}
		},
		uploadSuccess({ code, data }) {
			if (code == 0) {
				this.msgImgs.push(data);
			}
		},

		beforeRemove({ response }) {
			this.msgImgs = this.msgImgs.filter(item => item != response.data);
		},

		handleExceed() {
			alert('超过文件上传数量');
		},
		//移除视频文件
		videoBeforeRemove({ response }) {
			this.videos = this.videos.filter(item => item != response.data);
		},
		//上传视频
		videoUploadSuccess({ code, data }) {
			if (code == 0) {
				this.videos.push(data);
			}
		},
		// choooseModel(value) {
		// 	this.selectModelKey = value;
		// 	this.selectModel = this.models.find(item => item.value == value);
		// },

		choooseRole(role, type) {
			//type xz为协助角色  base为 默认ai角色
			if (role.isHelp) {
				this.isHelp = true;
			}
			this.selectRoleKey = role.id;
			if (type === 'xz') {
				this.selectRole = this.roles.find(item => item.id == role.id);
			} else {
				this.selectRole = this.baseRoles.find(item => item.id == role.id);
			}
			this.selectRole.type = type;
		},
		onXzRole() {
			if (this.roles.length === 0) {
				this.$message({ message: '暂无可协助角色', type: 'info' });
			}
		},

		cleanDialogs() {
			// this._chatDialogs = []
			this.$emit('clearChatDialogs');
			clearLunci(this._chatingId);
		},
		onShowPop(type) {
			if (type === 'video') {
				this.videoInputVisible = true;
				if (this.videos.length === 0) {
					this.$nextTick(() => {
						this.$refs.videoRef.clearFiles();
					});
				}
			}
			if (type === 'img') {
				this.imgInputVisible = true;
				if (this.msgImgs.length === 0) {
					this.$nextTick(() => {
						this.$refs.imgRef.clearFiles();
					});
				}
			}
		},
		async send() {
			if (this._chatObj && this._chatObj.helpStatus == 1) {
				this.$message({ message: '当前协作已完成', type: 'warning' });
				return;
			}
			if (!this.reqAiConfig.isSend) {
				this.$message({ message: 'AI模型错误或正在生成中，请稍后重试...', type: 'warning' });
				return;
			}
			if (!this.textarea) return;
			// 图片 / 视频生成模型仍走老链路（saveChatDialog + 轮询）
			if (this.modelDetail.modelType === 'image') {
				this.waitingImage();
				return;
			}
			if (this.modelDetail.modelType === 'video') {
				this.waitingVideo();
				return;
			}
			if (!this.reqAiConfig.aiModelGuid) {
				this.$message({ message: '请先选择 AI 模型', type: 'warning' });
				this.modelDialogVisible = true;
				return;
			}
			if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
				this.$message({ message: 'WebSocket 未连接，正在重连...', type: 'warning' });
				this.connectWs();
				return;
			}

			const content = this.textarea;
			this.textarea = '';
			let lastMsgId = '';
			const len = this._chatDialogs.length;
			if (len > 0) {
				lastMsgId = this._chatDialogs[len - 1].msgId;
			}

			// 附件：图片走 imgs（COS URL 数组），文件走 fileUrls（{name,url,type}）
			// 视频识别仍读 this.videos（来自老的视频上传弹窗）
			const imgs     = this.uploadedImages.map(img => img.url);
			const imgPreviews = this.uploadedImages.map(img => img.preview);
			const fileUrls = this.uploadedFiles.map(f => ({ name: f.name, url: f.url, type: f.type }));
			const videos   = this.videos;

			this._chatDialogs.push({
				msgId: 'new',
				chatRole: 'user',
				chatContent: content,
				// 用 preview（data URL）作为本地展示，避免 COS URL 还没生效时白屏
				imgUrls: imgPreviews.length > 0 ? imgPreviews : imgs,
				videoUrls: videos,
				files: fileUrls,
			});
			this._chatDialogs.push({
				msgId: 'new',
				chatRole: 'assistant',
				chatContent: '',
				starting: true,
				finished: false,
			});

			this.streamingIdx    = this._chatDialogs.length - 1;
			this._pendingLunci   = this._chatingId || null;
			this._eventsReceived = 0;
			this.reqAiConfig.isSend = false;

			// 清理已发送的附件，避免下一条消息重复带
			this.uploadedImages = [];
			this.uploadedFiles  = [];
			this.videos         = [];

			this.ws.send(JSON.stringify({
				type:           'send_message',
				content,
				imgs,
				videos,
				fileUrls,
				chatLunciGuid:  this._chatingId || '',
				aiModelGuid:    this.reqAiConfig.aiModelGuid,
				modelRef:       this.reqAiConfig.modelRef,
				chatScene:      'helpLunciDebug',
				sceneValue:     (this._chatObj && this._chatObj.guid) || '',
				lastMsgId:      this.reqAiConfig.isMultiple ? (lastMsgId === 'new' ? '' : lastMsgId) : '',
				token:          getToken(),
				app_type:       'xiaoyipc',
				app_guid:       this.$store.state.merchantGuid || '',
				enableThinking: this.enableThinking,
				temperature:    this.reqAiConfig.temperature,
				topP:           this.reqAiConfig.topP,
				maxOutputTokens: this.reqAiConfig.maxOutputTokens,
				systemPrompt:   this.reqAiConfig.systemPrompt,
				isMultiple:     this.reqAiConfig.isMultiple ? 1 : 0,
				isHelp:         '1',
				roleId:         this.selectRoleKey,
				roleType:       this.isHelp ? '2' : '1',
			}));

			this.toBottom();
		},

		// 滚动到最底部
		toBottom() {
			this.$nextTick(() => {
				let scrollDom = document.getElementById('chatbox');
				if (scrollDom) scrollDom.scrollTop = scrollDom.scrollHeight;
			});
		},

		// ──────────────────────────────────────────────
		// WebSocket 生命周期（与 layout-chat-main-v2 对齐）
		// ──────────────────────────────────────────────
		connectWs() {
			if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
				return;
			}
			this.ws = new WebSocket(config.wsUrl);

			this.ws.onopen = () => {
				this.wsConnected = true;
				if (this.reqAiConfig.aiModelGuid) {
					this.reqAiConfig.isSend = true;
				}
				if (this.wsReconnectTimer) {
					clearTimeout(this.wsReconnectTimer);
					this.wsReconnectTimer = null;
				}
				// 断线重连：恢复正在进行的流式会话
				if (this._pendingLunci) {
					this.ws.send(JSON.stringify({
						type:          'resume_chat',
						chatLunciGuid: this._pendingLunci,
						fromIdx:       this._eventsReceived,
						token:         getToken(),
					}));
				}
			};

			this.ws.onmessage = (e) => {
				let event;
				try { event = JSON.parse(e.data); } catch { return; }
				this.handleWsEvent(event);
			};

			this.ws.onclose = () => {
				this.wsConnected = false;
				if (!this._pendingLunci) {
					this.reqAiConfig.isSend = false;
				}
				this.wsReconnectTimer = setTimeout(() => this.connectWs(), 3000);
			};

			this.ws.onerror = () => {
				this.wsConnected = false;
			};
		},

		closeWs() {
			if (this.wsReconnectTimer) clearTimeout(this.wsReconnectTimer);
			if (this.ws) { try { this.ws.close(); } catch (_) { /* ignore */ } this.ws = null; }
		},

		// 处理 Node WS 事件（映射到老 ChatBox 字段：starting/finished/chatContent）
		handleWsEvent(event) {
			const d = this.streamingIdx >= 0 ? this._chatDialogs[this.streamingIdx] : null;
			if (this._pendingLunci) this._eventsReceived++;

			switch (event.type) {
				case 'text_chunk':
					if (d) { d.chatContent += event.content; d.starting = false; }
					break;
				case 'tool_start':
					if (d) { d.starting = false; }
					break;
				case 'tool_done':
					break;
				case 'reasoning_chunk':
					// ChatBox 旧版不展示推理内容，忽略以避免污染正文
					break;
				case 'done':
					if (d) { d.starting = false; d.finished = true; if (event.msgId) d.msgId = event.msgId; }
					this.streamingIdx = -1;
					this._pendingLunci   = null;
					this._eventsReceived = 0;
					this.reqAiConfig.isSend = true;
					this.toBottom();
					break;
				case 'error':
					if (d) {
						d.starting = false;
						d.finished = true;
						d.chatContent = '❌ ' + (event.message || '对话失败');
					}
					this.streamingIdx = -1;
					this._pendingLunci   = null;
					this._eventsReceived = 0;
					this.reqAiConfig.isSend = true;
					if (event.message) this.$message({ message: event.message, type: 'error' });
					break;
				case 'resume_not_found':
					this._pendingLunci   = null;
					this._eventsReceived = 0;
					this.reqAiConfig.isSend = true;
					break;
			}
		},

		onPause() {
			const dialog = this._chatDialogs[this._chatDialogs.length - 1];
			// WS 路径：主动关闭即可打断流式输出，下次发送时自动重连
			if (this.ws) {
				try { this.ws.close(); } catch (_) { /* ignore */ }
			}
			if (dialog) {
				dialog.starting = false;
				dialog.finished = true;
			}
			this.streamingIdx    = -1;
			this._pendingLunci   = null;
			this._eventsReceived = 0;
			this.reqAiConfig.isSend = true;
		},

		// ──────────────────────────────────────────────
		// 图片上传：选文件 → 本地预览 + 上传 COS（与 chat-v2 一致）
		// ──────────────────────────────────────────────
		async onImageSelect(e) {
			const files = Array.from(e.target.files);
			e.target.value = '';
			if (files.length === 0) return;

			this.imageUploading = true;
			const loading = this.$loading({ text: '图片上传中...', background: 'rgba(0,0,0,0.2)' });
			try {
				for (const file of files) {
					const preview = await new Promise(resolve => {
						const reader = new FileReader();
						reader.onload = ev => resolve(ev.target.result);
						reader.readAsDataURL(file);
					});
					const res = await uploadImgApi(file);
					if (res && res.code === 0 && res.data) {
						const url = res.data.url || res.data;
						this.uploadedImages.push({ preview, url });
					} else {
						this.$message({ message: `图片上传失败：${(res && res.msg) || '未知错误'}`, type: 'error' });
					}
				}
			} catch (err) {
				this.$message({ message: '图片上传失败，请重试', type: 'error' });
			} finally {
				loading.close();
				this.imageUploading = false;
			}
		},

		// ──────────────────────────────────────────────
		// 文件上传：上传到 COS，把 URL 存入 uploadedFiles（解析交给 PHP 后端）
		// ──────────────────────────────────────────────
		async onFileSelect(e) {
			const files = Array.from(e.target.files);
			e.target.value = '';
			if (files.length === 0) return;

			const SUPPORTED = ['txt', 'md', 'csv', 'docx', 'xlsx', 'xls', 'pdf', 'pptx'];
			const MAX_SIZE  = 5 * 1024 * 1024;

			const loading = this.$loading({ text: '文件上传中...', background: 'rgba(0,0,0,0.15)' });
			try {
				for (const file of files) {
					const ext = file.name.split('.').pop().toLowerCase();
					if (!SUPPORTED.includes(ext)) {
						this.$message({ message: `不支持 .${ext} 格式`, type: 'warning' });
						continue;
					}
					if (file.size > MAX_SIZE) {
						this.$message({ message: `${file.name} 超过 5MB 限制`, type: 'warning' });
						continue;
					}
					const res = await uploadDocFileApi(file);
					if (res && res.code === 0 && res.data) {
						const url = res.data.url || res.data;
						this.uploadedFiles.push({ name: file.name, url, type: ext });
					} else {
						this.$message({ message: `${file.name} 上传失败：${(res && res.msg) || '未知错误'}`, type: 'error' });
					}
				}
			} catch (err) {
				this.$message({ message: `文件上传失败：${err.message}`, type: 'error' });
			} finally {
				loading.close();
			}
		},

		fileTypeIcon(type) {
			const map = {
				xlsx: 'el-icon-document', xls: 'el-icon-document',
				docx: 'el-icon-document', csv: 'el-icon-document',
				txt:  'el-icon-document', md:  'el-icon-document',
				pdf:  'el-icon-document', pptx: 'el-icon-document',
			};
			return map[type] || 'el-icon-paperclip';
		},

		removeImage(i) { this.uploadedImages.splice(i, 1); },
		removeFile(i)  { this.uploadedFiles.splice(i, 1); },

		// 请求图片 , imgUrls
		async waitingImage() {
			let content = this.textarea;
			this.textarea = '';
			let saveMsgId = ''
			// 设置为生成中状态，禁止重复发送
			this.reqAiConfig.isSend = false;
			this._chatDialogs.push({ msgId: 'new', chatRole: 'user', chatContent: content });
			this._chatDialogs.push({
				msgId: 'new',
				chatRole: 'assistant',
				chatContent: '',
				starting: true,
				finished: true,
			});
			try {
				let res = await saveChatDialog({
					role: 'user',
					content,
					lastMsgId: '',
					contentType: 'text',
					aiModelGuid: this.modelPopCofig.guid,
					chatLunciGuid: this._chatingId,
					chatScene: 'helpLunciDebug',
					sceneValue: this._chatObj.guid,
				});
				if (res.code === 0) {
					saveMsgId = res.data.msgId;
				} else {
					this._chatDialogs[this._chatDialogs.length - 1].chatContent = res.msg
					this._chatDialogs[this._chatDialogs.length - 1].starting = false
					this._chatDialogs[this._chatDialogs.length - 1].finished = true
				}

				// this.msgImgs = [];

				this.toBottom();

				let url = await genImage({
					imgText: content,
					aiModelGuid: this.modelPopCofig.guid,
				});

				if (url) {
					let dialog = this._chatDialogs[this._chatDialogs.length - 1];
					dialog.starting = false;
					dialog.imgUrls = [url];

					let saveRes = await saveChatDialog({
						role: 'assistant',
						content: url,
						contentType: 'img',
						aiModelGuid: this.modelPopCofig.guid,
						lastMsgId: this.reqAiConfig.isMultiple ? saveMsgId : '',
						chatLunciGuid: this._chatingId,
						chatScene: 'helpLunciDebug',
						sceneValue: this._chatObj.guid,
					});
					if (saveRes.code === 0) {
						dialog.msgId = saveRes.data.msgId;
					}
				}
			} finally {
				// 恢复可操作状态
				this.reqAiConfig.isSend = true;
			}
		},
		// 生成视频
		async waitingVideo() {
			let content = this.textarea;
			this.textarea = '';
			// 设置为生成中状态，禁止重复发送
			this.reqAiConfig.isSend = false;
			this._chatDialogs.push({ msgId: 'new', chatRole: 'user', chatContent: content });
			this._chatDialogs.push({
				msgId: 'new',
				chatRole: 'assistant',
				chatContent: '',
				starting: true,
				finished: true,
			});

			let saveMsgId = ''
			try {
				let res = await saveChatDialog({
					role: 'user',
					content,
					lastMsgId: '',
					contentType: 'text',
					aiModelGuid: this.modelPopCofig.guid,
					chatLunciGuid: this._chatingId,
					chatScene: 'helpLunciDebug',
					sceneValue: this._chatObj.guid,
				});
				if (res.code === 0) {
					saveMsgId = res.data.msgId;
				} else {
					this._chatDialogs[this._chatDialogs.length - 1].chatContent = res.msg
					this._chatDialogs[this._chatDialogs.length - 1].starting = false
					this._chatDialogs[this._chatDialogs.length - 1].finished = true
					// 恢复可操作状态
					this.reqAiConfig.isSend = true;
					return;
				}

				// this.msgImgs = [];

				this.toBottom();
				let videoRes = await genVideoApi({
					userPrompt: content,
					aiModelGuid: this.modelPopCofig.guid,
				});
				if (videoRes.code == 0) {
					this.queryGenVideo(videoRes.data.orderNo, saveMsgId);
				} else {
					// 视频生成失败，恢复可操作状态
					this.reqAiConfig.isSend = true;
					this.$message({ message: videoRes.msg || '视频生成失败', type: 'error' });
				}
			} catch (error) {
				// 异常时恢复可操作状态
				this.reqAiConfig.isSend = true;
				this.$message({ message: error.message || '视频生成失败', type: 'error' });
			}
		},
		queryGenVideo(orderNo, saveMsgId) {
			let int = setInterval(async () => {
				try {
					let res = await queryGenVideoApi({ orderNo });
					if (res.code == 0) {
						if (res.data.status === 'success') {
							this.reqAiConfig.isSend = true;
							clearInterval(int);
							let dialog = this._chatDialogs[this._chatDialogs.length - 1];
							dialog.starting = false;
							dialog.videoUrls = [res.data.videoUrl];

							let saveRes = await saveChatDialog({
								role: 'assistant',
								content: res.data.videoUrl,
								contentType: 'video',
								aiModelGuid: this.modelPopCofig.guid,
								lastMsgId: this.reqAiConfig.isMultiple ? saveMsgId : '',
								chatLunciGuid: this._chatingId,
								chatScene: 'helpLunciDebug',
								sceneValue: this._chatObj.guid,
							});
							if (saveRes.code === 0) {
								dialog.msgId = saveRes.data.msgId
							}
						} else if (res.data.status === 'fail') {
							// 视频生成失败，恢复可操作状态
							this.reqAiConfig.isSend = true;
							clearInterval(int);
							let dialog = this._chatDialogs[this._chatDialogs.length - 1];
							dialog.starting = false;
							dialog.chatContent = '视频生成失败，请重试';
							this.$message({ message: '视频生成失败', type: 'error' });
						}
					}
				} catch (error) {
					// 查询异常时恢复可操作状态
					this.reqAiConfig.isSend = true;
					clearInterval(int);
					this.$message({ message: '视频生成查询失败', type: 'error' });
				}
			}, 5000);
		},
		// 自动选第一个可用模型（参考 chat-v2，进入页面就有默认模型可发）
		async autoSelectFirstModel() {
			const vendorRes = await getAiVendorListApi();
			const vendors   = (vendorRes && vendorRes.data) ? vendorRes.data : [];
			if (vendors.length === 0) return;

			const modelRes = await getAiVendorModelListApi({
				modelVendorSign: vendors[0].sign,
				modelType:       'text',
			});
			const models = (modelRes && modelRes.data) ? modelRes.data : [];
			if (models.length > 0) {
				this.onModelChoose(models[0]);
			}
		},

		// 模型选中回调（来自 ModelSelectDialog 的 @select 事件，或 autoSelectFirstModel）
		onModelChoose(item) {
			this.modelDetail = item;
			this.initChatOptions(item);

			// 老链路兼容（图片/视频生成沿用 modelPopCofig.guid）
			this.modelPopCofig.modelName = item.modelName;
			this.modelPopCofig.guid      = item.guid;

			// 新弹窗 & 按钮状态
			this.selectedModelName   = item.modelName;
			this.selectedModelVendor = item.modelVendorSign || '';
			this.reqAiConfig.aiModelGuid     = item.guid;
			// 协助空间保留旧执行器，仅让 PHP 按本人身份解析个人模型。
			this.reqAiConfig.modelRef        = item.modelRef || null;
			this.reqAiConfig.maxOutputTokens = item.maxOutputTokens || this.reqAiConfig.maxOutputTokens || 2048;
			// 可选思考模型默认打开
			this.enableThinking = item.isReasoning === 2;

			this.modelDialogVisible = false;
			if (this.wsConnected) this.reqAiConfig.isSend = true;
		},
		initChatOptions(item) {
			this.reqAiConfig.maxOutputTokens = Number((item.maxOutputTokens / 2).toFixed());
			this.reqAiConfig.topP = 0.6;
			this.reqAiConfig.temperature = 0.7;
			switch (item.modelType) {
				case 'text':
					this.reqAiConfig.placeholder = '请输入你的问题和需求';
					break;
				case 'image':
					this.reqAiConfig.placeholder = '请描述你想生成的图片(生成图片需等待1-2分钟)';
					break;
				case 'video':
					this.reqAiConfig.placeholder = '请描述你想生成的视频(生成视频需等待较长时间，生成时请耐心等待⌛️)';
					break;
				default:
					break;
			}
		},
	},
	mounted() {
		this.getClassList();
	},
};
</script>

<style scoped lang="scss">
.container {
	display: flex;
	width: 100%;
	height: 100%;

	.switch-box {
		border-top: 1px solid #ebebeb;
		margin-top: 20px;
		padding-top: 20px;

		.item {
			display: flex;
			justify-content: space-between;
			padding-top: 20px;

			.t {
				font-size: 12px;
				color: #333333;
			}
		}
	}

	.slider-box {
		margin-top: 20px;

		.slider {
			position: relative;

			.label {
				position: absolute;
				bottom: 30px;
				right: 0;
				color: #333333;
				font-size: 12px;
			}
		}
	}

	.options-box {
		padding: 20px;
		box-sizing: border-box;
		width: 300px;
		height: 100%;
		border-left: 1px solid #ebebeb;

		.label {
			color: #999999;
			font-size: 11px;
		}

		.title {
			font-size: 12px;
			color: #333333;
		}

		.input-box {
			position: relative;

			.el-dropdown-link {
				position: absolute;
				right: 4px;
				bottom: 4px;
				z-index: 9;
			}

			::v-deep .el-textarea__inner {
				border: 1px solid #6126f5 !important;
			}

			.inp {
				width: 100%;
			}
		}
	}
}

.role-drop-box {
	margin-bottom: 10px;

	.role-drop-title {
		width: 120px;
		margin-right: 10px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}

::v-deep .el-dropdown-menu__item i {
	margin-right: 0 !important;
}

.chat-input-box {
	border-radius: 10px;
	border: 1px solid #e1e2e5;
	position: relative;
	display: flex;
	align-items: center;
	padding-right: 10px;

	.input-box {
		::v-deep .el-textarea__inner {
			border: none;
			border-radius: 10px;
			font-size: 12px;
		}

		flex: 1;
	}

	.send-icon {
		cursor: pointer;

		.icon {
			width: 34px;
			height: 34px;
			display: block;
		}
	}

	// .el-dropdown-link {
	// 	position: absolute;
	// 	right: 4px;
	// 	bottom: 4px;
	// 	z-index: 9;
	// }
}

::v-deep .el-dialog__body {
	padding: 10px 20px 20px 20px;
}

::v-deep .github-markdown-body p {
	margin-bottom: 0px;
}

::v-deep .el-slider__bar {
	height: 10px;
}

::v-deep .el-slider__runway {
	height: 10px;
}

::v-deep .el-slider__button-wrapper {
	top: -14px;
}

.layout-chat-main {
	width: 100%;
	height: 100%;

	display: flex;
	flex-direction: column;
	flex: 1;

	.chat-header {
		border-bottom: 1px solid var(--border-color);
		padding: 14px 20px;
		display: flex;
		align-items: center;

		.left-box {
			display: flex;

			.top-public-btn {
				width: 111px;
				height: 36px;
				border-radius: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 12px;

				.icon {
					display: block;
					width: 20px;
					height: 20px;
					margin-right: 4px;
				}
			}

			.no-completed-btn {
				border: 1px solid #4958ec;
				color: #4958ec;
			}

			.completed-btn {
				border: 1px solid #07c160;
				color: #07c160;
			}
		}

		.right-box {
			display: flex;
			flex: 1;
			justify-content: end;

			.top-public-btn {
				width: 111px;
				height: 36px;
				border-radius: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 12px;
				cursor: pointer;

				.icon {
					display: block;
					width: 20px;
					height: 20px;
					margin-right: 4px;
				}
			}

			.end-btn {
				background: linear-gradient(91deg, #fe6947 0%, #fd462e 100%);
				color: #ffffff;
			}

			.back-btn {
				background: linear-gradient(270deg, #145bec 0%, #3670f8 100%);
				color: #ffffff;

				&.active {
					background: #f6f7f9;
					color: #999999;
					cursor: not-allowed;
				}
			}
		}
	}

	.chat-input {
		border-top: 1px solid var(--border-color);
		padding: 10px 20px;
	}

	.chat-box {
		flex: 1 1;
		overflow: auto;
		padding: 10px 0;
	}

	.send {
		height: 40px;
		width: 80px;
	}

	.popper-box {
		position: relative;

		// .dropdown-warp {
		//   position: absolute;
		//   bottom: 43px;
		//   left: 0px;
		//   z-index: 9;
		//   display: flex;
		// }

		.dropdown-box {
			width: 150px;
			min-height: 200px;
			background: #ffffff;
			box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.08);
			border-radius: 8px;
			border: 1px solid #ebebeb;
			position: absolute;
			bottom: 43px;
			left: 0px;
			z-index: 9;
			box-sizing: border-box;

			.item {
				display: flex;
				justify-content: space-between;
				padding: 10px 15px;
				width: 100%;
				border-radius: 4px;
				color: #333333;
				font-size: 14px;
				box-sizing: border-box;
				align-items: center;
				cursor: pointer;

				&:hover,
				&.active {
					background: #f6f7f9;
				}
			}
		}

		.children-dropdown-box {
			position: absolute;
			bottom: 43px;
			left: 155px;
			width: 600px;
			min-height: 200px;
			background: #ffffff;
			box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.08);
			border-radius: 8px;
			border: 1px solid #ebebeb;
			display: flex;
			padding: 10px;
			box-sizing: border-box;
			z-index: 9;

			.tab {
				display: flex;
				flex-direction: column;
				justify-content: center;

				.item {
					width: 50px;
					height: 30px;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #333333;
					font-size: 14px;
					border-radius: 3px;
					margin-bottom: 6px;
					cursor: pointer;

					&:last-child {
						margin-bottom: 0px;
					}

					&:hover,
					&.active {
						background: #f6f7f9;
					}
				}
			}

			.content {
				width: 100%;
				flex: 1;
				padding-left: 10px;
				overflow: hidden;
				box-sizing: border-box;

				.empty {
					height: 100%;
					display: flex;
					align-items: center;
					padding-left: 30px;
					font-size: 12px;
				}

				.item {
					padding: 4px 10px;
					display: flex;
					box-sizing: border-box;
					font-size: 12px;
					// width: 100%;
					overflow: hidden;
					/* 确保超出容器的文本被隐藏 */
					white-space: nowrap;
					/* 防止文本换行 */
					text-overflow: ellipsis;
					cursor: pointer;

					.name {
						width: 100px;
						flex-shrink: 0;
						overflow: hidden;
						/* 确保超出容器的文本被隐藏 */
						white-space: nowrap;
						/* 防止文本换行 */
						text-overflow: ellipsis;
					}

					.price {
						width: 75px;
						flex-shrink: 0;
					}

					.specific {
						flex: 1;
						overflow: hidden;
						/* 确保超出容器的文本被隐藏 */
						white-space: nowrap;
						/* 防止文本换行 */
						text-overflow: ellipsis;
					}

					&:hover,
					&.active {
						background: hsl(220, 20%, 97%);
						color: #6126f5;
					}
				}
			}
		}

		.model-public-btn {
			border-radius: 8px;
			border: 1px solid #dee0e4;
			font-size: 12px;
			color: #737b8d;
			cursor: pointer;
			padding: 6px 10px;
			width: 160px;
			overflow: hidden;
			/* 确保超出容器的文本被隐藏 */
			white-space: nowrap;
			/* 防止文本换行 */
			text-overflow: ellipsis;

			&.active,
			&:hover {
				border-color: #f6f7f9;
				background: #f6f7f9;
			}
		}
	}

	.opt-panel {
		margin-bottom: 10px;
		display: flex;

		// .el-button {
		// 	padding: 2px 11px;
		// 	font-size: 12px;
		// 	font-weight: normal;

		// 	i {
		// 		font-size: 12px;
		// 	}
		// }
	}
}

.role-select-btn {
	border-radius: 8px;
	border: 1px solid #dee0e4;
	font-size: 12px;
	color: #737b8d;
	cursor: pointer;
	padding: 6px 10px;
	width: 160px;
	overflow: hidden;
	/* 确保超出容器的文本被隐藏 */
	white-space: nowrap;
	/* 防止文本换行 */
	text-overflow: ellipsis;

	&:hover {
		border-color: #f6f7f9;
		background: #f6f7f9;
	}
}

.clean-chat-btn {
	border-radius: 8px;
	border: 1px solid #dee0e4;
	font-size: 12px;
	color: #737b8d;
	cursor: pointer;
	padding: 6px 10px;
	overflow: hidden;
	/* 确保超出容器的文本被隐藏 */
	white-space: nowrap;
	/* 防止文本换行 */
	text-overflow: ellipsis;

	&:hover {
		border-color: #f6f7f9;
		background: #f6f7f9;
	}
}

/* 上传按钮（图片 / 文件，与 chat-v2 视觉一致） */
.upload-btn {
	display: flex;
	align-items: center;
	gap: 4px;
	height: 28px;
	padding: 0 10px;
	border-radius: 6px;
	font-size: 12px;
	color: #666;
	cursor: pointer;
	transition: background 0.15s, color 0.15s;
	user-select: none;

	i { font-size: 14px; }

	&:hover {
		background: rgba(97, 38, 245, 0.07);
		color: #6126F5;
	}
}

/* 附件预览区（图片缩略图 + 文件卡片） */
.attachments {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 8px 0 4px;

	.attachment-img {
		position: relative;
		.img-thumb {
			width: 60px;
			height: 60px;
			object-fit: cover;
			border-radius: 6px;
			border: 1px solid #e0e0e0;
			display: block;
		}
	}

	.attachment-file {
		display: flex;
		align-items: center;
		gap: 5px;
		min-height: 36px;
		padding: 4px 10px;
		border-radius: 6px;
		border: 1px solid #e0e0e0;
		background: #f8f8f8;
		position: relative;

		.file-icon { color: #6126F5; font-size: 15px; flex-shrink: 0; }
		.file-info {
			display: flex;
			flex-direction: column;
			min-width: 0;
		}
		.file-name {
			font-size: 12px;
			color: #444;
			max-width: 160px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.remove-btn {
		position: absolute;
		top: -7px;
		right: -7px;
		font-size: 16px;
		color: #bbb;
		cursor: pointer;
		background: #fff;
		border-radius: 50%;
		line-height: 1;
		&:hover { color: #f56c6c; }
	}
}

/* 模型选择按钮（与 chat-v2 视觉一致） */
.model-select-btn {
	display: flex;
	align-items: center;
	gap: 6px;
	height: 32px;
	padding: 0 14px;
	border-radius: 8px;
	border: 1.5px solid #c4b5fd;
	font-size: 13px;
	font-weight: 500;
	color: #5b21b6;
	background: linear-gradient(135deg, #faf5ff 0%, #ede9fe 100%);
	cursor: pointer;
	transition: all 0.2s;
	user-select: none;
	max-width: 240px;
	box-shadow: 0 1px 4px rgba(97, 38, 245, 0.1);

	&:hover {
		border-color: #6126F5;
		background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
		box-shadow: 0 2px 8px rgba(97, 38, 245, 0.18);
	}

	.model-vendor-dot {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		flex-shrink: 0;
	}

	.model-name {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>
